import { Alert, Snackbar } from '@mui/material';
import React from 'react'

const CustomToast = (props) => {
    const {open, toastMessage, setToast, toastType } = props;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setToast(false);
      };

return (
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
    <Alert
        onClose={handleClose}
        severity={toastType}
        variant="filled"
        sx={{ width: '100%' }}  
    >
        {toastMessage}
    </Alert>
</Snackbar>
)
}

export default CustomToast